import { Dropdown } from 'antd';
import { useState } from 'react';
import { ReactSVG } from 'react-svg';
import { DropdownContainer, Column, ColumnsContainer, ColumnHeading, SectorCell, ButtonsContainer, ActionButton } from './ContextMenu.style';
import { useAuthStateValue } from '../../../../context/AuthContext';
import xMarkIcon from '../../../../assets/images/icons/xmark-solid.svg';
import commentIcon from '../../../../assets/images/icons/comment-dots-solid-full.svg';
import clockIcon from '../../../../assets/images/icons/clock-regular.svg';

const ContextMenu = (props) => {
  const [open, setOpen] = useState();
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const { children, addNoteModalRef } = props;
  const { loggedUser } = useAuthStateValue();

  const { modified, controllerId, timeFrom, timeTo, sectorId, sectorRoleId, setModifiedData, editModeOn, assignment, comment, controllerFullName, sectorOpeningTime } = props;
  const exeRoleId = loggedUser?.sectorRoles?.find((el) => el?.shortName === 'EXE')?.id;
  const plcRoleId = loggedUser?.sectorRoles?.find((el) => el?.shortName === 'PLC')?.id;
  const sectorInfo = loggedUser?.sectors?.find((el) => (el?.id === sectorId));
  const sectorRoleInfo = loggedUser?.sectorRoles?.find((el) => (el?.id === sectorRoleId));

  const handleOpenChange = (flag) => {
    setOpen(flag);
    setSelectedAssignment(null);
  }

  const changeSector = (value, role) => {
    const sectorDetails = loggedUser?.sectors?.find((el) => (el?.id === value));
    const isRealSector = !sectorDetails?.type === 'SECTOR' || 'REQUIRES_SECTOR';
    if (sectorDetails?.type === 'REQUIRES_SECTOR') {
      if (sectorDetails?.shortName === selectedAssignment?.value) {
        setSelectedAssignment(null);
      } else {
        setSelectedAssignment({
          role,
          value: sectorDetails?.shortName,
          id: value
        });
      }
      return;
    }
    if (!modified) {
      setModifiedData((prevState) => [
        ...(prevState ? prevState : []),
        [
          ...(prevState?.[prevState?.length - 1] ? prevState?.[prevState?.length - 1] : []),
          {
            controllerId,
            timeFrom,
            timeTo,
            type: 'REMOVE',
            sectorId,
            sectorRoleId,
            assignment,
            comment,
            minuteFrom: sectorOpeningTime
          },
          {
            controllerId,
            timeFrom,
            timeTo,
            type: 'ADD',
            sectorId: value,
            sectorRoleId: role === 'EXE' ? exeRoleId : role === 'PLC' ? plcRoleId : null,
            assignment: (selectedAssignment && isRealSector)
                ? (selectedAssignment?.value === 'ŠS/KL'
                    ? 'SHIFT_MANAGER_AND_CONTROLLER' : selectedAssignment?.value === 'OJTI/ASSE'
                        ? 'OJTI_AND_ASSE' : selectedAssignment?.value === 'SATCO/KL'
                            ? 'SATCO_AND_CONTROLLER' : selectedAssignment?.value)
                : 'REGULAR',
            comment,
            minuteFrom: sectorOpeningTime
          }
        ]
      ]);
    } else {
      setModifiedData((prevState) => {
        const newStateArray = [...prevState];
        const newestModifiedDataArray = [];
        prevState?.[prevState?.length - 1]?.forEach((el) => {
          if (el?.timeFrom === timeFrom && el?.timeTo === timeTo && el?.controllerId === controllerId && el?.type !== 'REMOVE') {
            newestModifiedDataArray.push({
              controllerId: el?.controllerId,
              timeFrom: el?.timeFrom,
              timeTo: el?.timeTo,
              type: 'ADD',
              sectorId: value,
              sectorRoleId: role === 'EXE' ? exeRoleId : role === 'PLC' ? plcRoleId : null,
              assignment: (selectedAssignment && isRealSector)
                  ? (selectedAssignment?.value === 'ŠS/KL'
                      ? 'SHIFT_MANAGER_AND_CONTROLLER' : selectedAssignment?.value === 'OJTI/ASSE'
                          ? 'OJTI_AND_ASSE' : selectedAssignment?.value === 'SATCO/KL'
                              ? 'SATCO_AND_CONTROLLER' : selectedAssignment?.value)
                  : 'REGULAR',
              comment: el?.comment,
              minuteFrom: el?.minuteFrom
            });
          } else newestModifiedDataArray.push(el);
        });
        newStateArray.push(newestModifiedDataArray);
        return newStateArray;
      });
    }
    setOpen(false);
  }

  const removeHandler = () => {
    if (!modified) {
      setModifiedData((prevState) => [
        ...(prevState ? prevState : []),
        [
          ...(prevState?.[prevState?.length - 1] ? prevState?.[prevState?.length - 1] : []),
          {
            controllerId,
            timeFrom,
            timeTo,
            type: 'REMOVE',
            sectorId,
            sectorRoleId,
            assignment,
            comment,
            minuteFrom: sectorOpeningTime
          }
        ]
      ]);
    } else if (modified) {
      setModifiedData((prevState) => {
        const newStateArray = [...prevState];
        const newestModifiedDataArray = [];
        prevState?.[prevState?.length - 1]?.forEach((el) => {
          if (el?.timeFrom === timeFrom && el?.timeTo === timeTo && el?.controllerId === controllerId && el?.type !== 'REMOVE') {
            return;
          }
          newestModifiedDataArray.push(el);
        });
        newStateArray.push(newestModifiedDataArray);
        return newStateArray;
      });
    }
    handleOpenChange(false);
  };

  const editSectorOpeningTimeHandler = () => {
    props?.sectorOpeningTimeModalRef?.current?.showDialog({
      controllerId,
      timeFrom,
      timeTo,
      sectorId,
      assignment,
      sectorRoleId,
      modified,
      minuteFrom: sectorOpeningTime,
      comment,
      sectorShortName: sectorInfo?.shortName,
      sectorRoleShortName: sectorRoleInfo?.shortName,
      controllerFullName
    });
    setOpen(false);
  };

  const renderExeSectors = () => {
    const sectorCellsArr = [];
    loggedUser?.sectors?.forEach((sector) => {
      const isRealSector = sector.type === 'SECTOR' || sector.type === 'REQUIRES_SECTOR';
      const isDisabledCell = (selectedAssignment?.value && sector.type !== 'SECTOR') || selectedAssignment?.role === 'PLC';
      if (isRealSector) {
        sectorCellsArr.push(
          <SectorCell
            className={(!!selectedAssignment?.value && selectedAssignment?.id === sector?.id && selectedAssignment?.role === 'EXE') ? 'selectedAssignment' : (isDisabledCell ? 'disabled' : '')}
            sectorId={sector?.id}
            onClick={() => { if (!isDisabledCell) changeSector(sector?.id, 'EXE') }}
          >
            {sector?.shortName}
          </SectorCell>
        );
      }
    })
    return sectorCellsArr;
  }

  const renderPlcSectors = () => {
    const sectorCellsArr = [];
    loggedUser?.sectors?.forEach((sector) => {
      const isRealSector = sector.type === 'SECTOR' || sector.type === 'REQUIRES_SECTOR';
      const isDisabledCell = (selectedAssignment?.value && sector.type !== 'SECTOR') || selectedAssignment?.role === 'EXE';
      if (isRealSector) {
        sectorCellsArr.push(
          <SectorCell
            className={(!!selectedAssignment?.value && selectedAssignment?.id === sector?.id && selectedAssignment?.role === 'PLC') ? 'selectedAssignment' : (isDisabledCell ? 'disabled' : '')}
            sectorId={sector?.id}
            onClick={() => { if (!isDisabledCell) changeSector(sector?.id, 'PLC') }}
          >
            {sector?.shortName}
          </SectorCell>
        );
      }
    })
    return sectorCellsArr;
  }

  const renderCommonObligations = () => {
    const array = [];
    loggedUser?.sectors?.forEach((sector) => {
      const isDisabledCell = selectedAssignment?.value === 'OJTI' || selectedAssignment?.value === 'ASSE';
      if (sector.type === 'ROLE' || sector.type === 'PAUSE') {
        array.push(
          <SectorCell
            onClick={() => { if (!isDisabledCell) changeSector(sector?.id) }}
            sectorId={sector?.id}
            className={isDisabledCell ? 'disabled' : ''}
          >
            {sector?.shortName}
          </SectorCell>
        );
      }
    });
    return array;
  };

  return (
    <Dropdown
      open={open}
      trigger={editModeOn ? ['contextMenu'] : ['']}
      onOpenChange={handleOpenChange}
      dropdownRender={() => {
        return (
          <DropdownContainer>
            <ColumnsContainer>
              <Column>
                <ColumnHeading>PLC</ColumnHeading>
                {renderPlcSectors()}
              </Column>
              <Column>
                <ColumnHeading>EXE</ColumnHeading>
                {renderExeSectors()}
              </Column>
            </ColumnsContainer>
            {renderCommonObligations()}
            <ButtonsContainer>
              {/* <ActionButton className={modified ? 'enabled' : 'disabled'} onClick={modified ? revertHandler : null}><ReactSVG src={revertIcon} /></ActionButton> */}
              <ActionButton className="enabled" onClick={removeHandler}><ReactSVG src={xMarkIcon} /></ActionButton>
              <ActionButton className="enabled" onClick={editSectorOpeningTimeHandler}><ReactSVG style={{ marginTop: '1px' }} width={15} height={15} src={clockIcon} /></ActionButton>
              <ActionButton
                className="enabled"
                onClick={() => {
                  addNoteModalRef?.current.showDialog({
                    controllerId,
                    timeFrom,
                    timeTo,
                    sectorId,
                    assignment,
                    sectorRoleId,
                    modified,
                    minuteFrom: sectorOpeningTime,
                    comment,
                    sectorShortName: sectorInfo?.shortName,
                    sectorRoleShortName: sectorRoleInfo?.shortName,
                    controllerFullName
                  });
                  setOpen(false);
                }}
              >
                <ReactSVG width={15} height={15} src={commentIcon} />
              </ActionButton>
            </ButtonsContainer>
          </DropdownContainer>
        )
      }}
    >
      {children}
    </Dropdown>
  )
}

export default ContextMenu;
